/**
 * Theme JavaScript
 * Vanilla JS for Shopify theme functionality
 */

(function () {
  "use strict";

  // Theme initialization
  const theme = window.theme || {};

  /**
   * Format money values
   */
  theme.formatMoney = function (cents, format) {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    let value = "";
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || theme.moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ",";
      decimal = decimal || ".";

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      const parts = number.split(".");
      const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
      const centsAmount = parts[1] ? decimal + parts[1] : "";

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };

  /**
   * Update cart count across all elements (desktop and mobile)
   */
  theme.updateCartCount = async function () {
    try {
      const response = await fetch("/cart.js");
      const cart = await response.json();
      const count = cart.item_count || 0;

      // Update desktop cart count elements
      const cartCountElements = document.querySelectorAll("[data-cart-count]");
      cartCountElements.forEach((el) => {
        if (count > 0) {
          el.textContent = ` (${count})`;
          el.style.display = "inline";
        } else {
          el.style.display = "none";
        }
      });

      // Update mobile cart count elements
      const mobileCartCountElements = document.querySelectorAll("[data-mobile-cart-count]");
      mobileCartCountElements.forEach((el) => {
        if (count > 0) {
          el.textContent = ` (${count})`;
          el.style.display = "inline";
        } else {
          el.style.display = "none";
        }
      });

      // Update mobile header cart count elements
      const mobileHeaderCartCountElements = document.querySelectorAll(
        "[data-mobile-header-cart-count]",
      );
      mobileHeaderCartCountElements.forEach((el) => {
        if (count > 0) {
          el.textContent = ` (${count})`;
          el.style.display = "inline";
        } else {
          el.style.display = "none";
        }
      });

      // Update cart link aria-labels for accessibility
      const cartLinks = document.querySelectorAll(
        "[data-cart-link], [data-mobile-cart-link], [data-mobile-header-cart-link]",
      );
      cartLinks.forEach((link) => {
        const label = count > 0 ? `Cart (${count})` : "Cart";
        link.setAttribute("aria-label", label);
      });

      return count;
    } catch (error) {
      console.error("Error updating cart count:", error);
      return 0;
    }
  };

  /**
   * Initialize theme
   */
  theme.init = function () {
    console.log("Theme initialized");

    // Initialize cart count on page load
    theme.updateCartCount();

    // Listen for cart updates from any component
    document.addEventListener("cart:updated", function (event) {
      theme.updateCartCount();
    });

    // Also listen for Shopify's native cart update events
    document.addEventListener("cart:refresh", function () {
      theme.updateCartCount();
    });
  };

  // Run init on DOM ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", theme.init);
  } else {
    theme.init();
  }

  // Export theme
  window.theme = theme;
})();
